import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/landing/footer/Footer.js';
import Security from './components/security/Security.js';
import Managed from './components/managed/Managed.js';
import Assign from './components/assign/Assign.js';
import Contactus from './components/contactus/Contactus.js';
import Loader from './hooks/Loader.js';
import { useEffect, useState } from 'react';
import Power from './components/power/Power.js';
import ComingSoon from './components/ComingSoon/ComingSoon.js';
import Bussiness from './components/bussiness/Bussiness.js';
import Portfolio from './components/portfolio/Portfolio.js';


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isFirstVisit = !localStorage.getItem("hasVisited");

    const timeout = setTimeout(() => {
      setLoading(false);
      localStorage.setItem("hasVisited", "true");
    }, isFirstVisit ? 6000 : 2000);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      {loading && (
        <Loader />
      )}
      <Router>
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/compliance-governance' component={Security} />
          <Route exact path='/managed-it-services' component={Managed} />
          <Route exact path='/security-assessments' component={Assign} />
          <Route exact path='/contactus' component={Contactus} />
          <Route exact path='/accountant-on-demand' component={Bussiness} />
          <Route exact path='/business-process-automation' component={Power} />
          <Route exact path='/coming-soon' component={ComingSoon} />
          <Route exact path='/portfolio' component={Portfolio} />
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;




